import actions from "./actions";

const initState = {
    statementReadState: false,
    paymentUrl: false,
    cs: false,
    ct: false,
    company: {},
    statement: {},
    statementPayexState: false,
    eStatementNotSubscribed: false,
};

export default function appReducer(state = initState, action = {}) {
    switch (action.type) {
        case actions.PUBLIC_STATEMENT_READ_REQUEST:
            return {
                ...state,
                statementReadState: 'request',
            };
        case actions.PUBLIC_STATEMENT_READ_SUCCESS:
            return {
                ...state,
                statementReadState: 'success',
                company: action.company,
                statement: action.statement,
            };
        case actions.PUBLIC_STATEMENT_READ_V2_REQUEST:
            return {
                ...state,
                statementReadState: 'request',
            };
        case actions.PUBLIC_STATEMENT_READ_V2_SUCCESS:
            return {
                ...state,
                statementReadState: 'success',
                company: action.company,
                statement: action.statement,
                paymentUrl: action.payment_url,
                cs: action.cs,
                ct: action.ct,
            };
        case actions.PUBLIC_STATEMENT_READ_V2_ERROR: {
            if (action.error.statusCode === 403) {
                return {
                    ...state,
                    statementReadState: 'error',
                    eStatementNotSubscribed: true,
                };
            }
            return {
                ...state,
                statementReadState: 'error',
            };
        }
        case actions.PUBLIC_STATEMENT_READ_STATEMENT_PAYMENT_REQUEST:
            return {
                ...state,
                statementPaymentReadState: 'request',
            };
        case actions.PUBLIC_STATEMENT_READ_STATEMENT_PAYMENT_SUCCESS:
            return {
                ...state,
                statementPaymentReadState: 'success',
            };
        case actions.PUBLIC_STATEMENT_RESET_STATE:
            return {
                ...initState,
            };
        case actions.PUBLIC_STATEMENT_CREATE_PAYEX_PAYMENT_REQUEST:
            return {
                ...state,
                statementPayexState: 'request',
                request: action.request,
                openInNewTab: action.openInNewTab,
            };
        case actions.PUBLIC_STATEMENT_CREATE_PAYEX_PAYMENT_SUCCESS:
            return {
                ...state,
                statementPayexState: 'success',
            };
        default:
            return state;
    }
}
